"use strict";

exports.__esModule = true;
exports.default = void 0;

var _buttonToolbar = _interopRequireDefault(require("./button-toolbar"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BButtonToolbar: _buttonToolbar.default,
  BBtnToolbar: _buttonToolbar.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/button-toolbar/index.js
// module id = 3oid
// module chunks = 0